/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "6.3.0";
